import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';
import { Paragraph } from 'ViatoUi/Shared/Typo';

const ErrorMessage = ({ errorMessages }) => {
	return (
		<>
			<Spacer height='s' />
			{errorMessages.map(errorMessage => (
				<FlexBox key={errorMessage} alignItems='center' style={{ width: '330px', maxWidth: '100%' }}>
					<Icon color='error' icon='fa-exclamation-circle' iconWeight='fal' size='s' /> <Spacer width='s' />
					<Paragraph color='error' font='small'>
						{errorMessage}
					</Paragraph>
				</FlexBox>
			))}
		</>
	);
};

ErrorMessage.propTypes = {
	errorMessages: PropTypes.array.isRequired
};

export default ErrorMessage;
